import { render, staticRenderFns } from "./ActivityParameterUpdate.vue?vue&type=template&id=20640615&scoped=true"
import script from "./ActivityParameterUpdate.vue?vue&type=script&lang=js"
export * from "./ActivityParameterUpdate.vue?vue&type=script&lang=js"
import style0 from "./ActivityParameterUpdate.vue?vue&type=style&index=0&id=20640615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20640615",
  null
  
)

export default component.exports